export const POST_CONCLUSION_ERROR =
  "Не удалось добавить заключение, попробуйте повторить позднее";
export const GET_CONCLUSION_ERROR = "Не удалось загрузить заключение";
export const CONCLUSION_BUTTON_TEXT =
  "Добавить заключение или комментарий для пациента";
